import FavoriteSidebar from './container'
export { FavoriteSidebar }
export default FavoriteSidebar